document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.emya-home').forEach(function (root) {
    var reveals = root.querySelectorAll('.emya-reveal, .emya-reveal-stagger');
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.15, rootMargin: '0px 0px -60px 0px' });
    reveals.forEach(function (el) { io.observe(el); });

    var orb = root.querySelector('.emya-orb');
    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (orb && !reduceMotion) {
      var tx = 0, ty = 0, cx = 0, cy = 0;
      window.addEventListener('mousemove', function (e) {
        tx = (e.clientX / window.innerWidth - 0.5) * 40;
        ty = (e.clientY / window.innerHeight - 0.5) * 40;
      });
      (function loop() {
        cx += (tx - cx) * 0.05;
        cy += (ty - cy) * 0.05;
        orb.style.marginLeft = cx + 'px';
        orb.style.marginTop = cy + 'px';
        requestAnimationFrame(loop);
      })();
    }
  });
});
